import styled, { css } from 'styled-components';

import { SWReactCountryIcons } from '@similarweb/icons';

export const StyledCountryIcon = styled(SWReactCountryIcons)<{ size?: string }>`
  ${({ size = '16px' }: { size?: string }) => css`
    width: ${size};
    height: ${size};
    min-width: ${size};
    min-height: ${size};
  `}
`;

export const StyledTooltipContentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
`;

export const StyledTooltipContentItemText = styled.div`
  margin-top: 1px;
`;
